import { useState } from "react";
import { api } from "../api";
import { Btn, Card, Field, Input } from "./ui";
import Icon from "./Icon";

export default function ChangePassword({ onClose }) {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);

  const submit = async () => {
    setErr("");
    if (nw.length < 6) return setErr("New password must be at least 6 characters.");
    if (nw !== confirm) return setErr("New passwords don't match.");
    try { await api.changePassword({ current_password: cur, new_password: nw }); setDone(true); }
    catch (e) { setErr(e.message); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4" onClick={onClose}>
      <Card className="w-full max-w-sm p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-slate-900">Change password</h2>
          <button onClick={onClose} className="text-slate-400"><Icon name="x" size={18} /></button>
        </div>
        {done ? (
          <div className="text-center py-4">
            <Icon name="check" size={28} className="mx-auto mb-2 text-green-600" />
            <p className="text-sm text-slate-600">Your password has been updated.</p>
            <Btn className="mt-4" onClick={onClose}>Done</Btn>
          </div>
        ) : (
          <div className="space-y-3">
            <Field label="Current password"><Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} /></Field>
            <Field label="New password"><Input type="password" value={nw} onChange={(e) => setNw(e.target.value)} /></Field>
            <Field label="Confirm new password"><Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} /></Field>
            {err && <div className="text-sm text-red-600">{err}</div>}
            <div className="flex justify-end gap-2 pt-1"><Btn variant="outline" onClick={onClose}>Cancel</Btn><Btn onClick={submit}>Update</Btn></div>
          </div>
        )}
      </Card>
    </div>
  );
}
